import React from "react";
import Bs from "./_bs";

class _maintenance extends React.Component {

    state = {
        show: sessionStorage.getItem("maintenance_terms") ? false : true
    }

    componentDidMount() {
        this.setState({show: false});
    }


    render() {
        return (
            <>
                {this.state.show && (
                    <Bs div className="fixed-maintenance">
                        <Bs alert variant="warning" onClose={() => {
                            sessionStorage.setItem("maintenance_terms", false);
                            this.setState({ show: false });
                        }} dismissible>
                            <Bs row>
                                <Bs col>
                                    Z provozních důvodu je ve dnech 16.5. -19.5. otevírací doba osobního příjmu a výdeje zakázek jen: 8:00 – 14:30 hod. Děkujeme za pochopení.
                                </Bs>
                            </Bs>
                        </Bs>
                    </Bs>
                )}
            </>
        )
    }
}

export default _maintenance